export const WorkbenchRouting = [
  {
    path: "/platform-electronic-visa/workbench",
    name: "workbench",
    // component: () => import("@/views/dashboard/welcome/index.vue"),
    component: () => import("@/views/platform-electronic-visa/workbench/index.vue"),
    meta: { title: "工作台", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/workbench/contract-comparison",
    name: "workbenchContractComparison",
    component: () =>
      import("@/views/platform-electronic-visa/workbench/contractComparison/index.vue"),
    meta: { title: "合同对比", icon: "dashboard" },
  },
  {
    path: "/platform-electronic-visa/workbench/contract-review",
    name: "workbenchContractReview",
    component: () => import("@/views/platform-electronic-visa/workbench/contractReview/index.vue"),
    meta: { title: "合同审查", icon: "dashboard" },
  },
];
// //资讯
// export const InformationRouting = {
//   path: "/informationIndex",
//   name: "informationIndex",
//   component: () => import("@/views/dashboard/welcome/index.vue"),
//   meta: { title: "资讯", icon: "dashboard" },
// };

// export const PosterRouting = {
//   path: "/poster",
//   name: "poster",
//   hidden: true,
//   component: () =>
//     import(/* webpackChunkName: "dashboard-welcome" */ "@/views/dashboard/poster/index.vue"),
//   meta: { title: "省钱宝", icon: "dashboard" },
// };
